// useDeviceMatch.ts
import { useMediaQuery } from "react-responsive";
import { useContext } from "react";
import { ThemeContext } from "styled-components";

export const useDeviceMatch = (devices = ["mobile", "tablet", "desktop"]) => {
    const theme = useContext(ThemeContext);
    const { mediaQuerySizes = {} } = theme || {};
    const isMobile = useMediaQuery({
        maxWidth: mediaQuerySizes.mobile
    });

    const isTablet = useMediaQuery({
        minWidth: mediaQuerySizes.mobile + 1,
        maxWidth: mediaQuerySizes.desktop - 1
    });

    const isDesktop = useMediaQuery({
        minWidth: mediaQuerySizes.desktop
    });

    const matches = {
        mobile: isMobile,
        tablet: isTablet,
        desktop: isDesktop
    };

    return devices.some(device => matches[device]);
};
